<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4">
						<h4 class="mm-0 mb-4">Programs <router-link :to="{ name : 'admin.courses.create'}" tag="a" class="ml-2 button buttton-small small-button">
							    	<img src="../../../assets/images/icons/solid/plus_white.svg" width="14" />
									new
								</router-link></h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
		</div><!--row-->
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row justify-content-between align-items-end mb-2">
					<div class="col-12 col-lg-5">
						<div class="input-content no-border m-0 ml-2">
							<input v-model="search" placeholder="Search by name" type="text" @keyup="getCourses()" />
						</div>
					</div><!--col-->
					<div class="col-12 col-lg-5">
						<multiselect v-model="per_page" :options="[10, 25, 50, 100]" @select="changePerPage"
							:allow-empty="false" :show-labels="false"></multiselect>
					</div><!--col-->
				</div><!--row-->
				
				<div class="table-responsive">
					<table class="table table-bordered">
						<thead>
							<tr>
								<th class="">Name</th>
								<th class="text-center width-130">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in courses" >
								<td><router-link :to="{ name: 'admin.courses.detail', params : { id : item.id } }" tag="a" class="bold">{{ item.name }}</router-link></td>
								<td class="text-center">
									
				      				<div class="trigger-hidden-content ml-1 d-inline-block">
										<span class=" button">
											<img width="15" src="../../../assets/images/icons/solid/ellipsis-h_white.svg">
										</span>
										<div class="hidden-content hc-right-bottom">
											<div>
												<ul class="list-unstyled text-left">
													<li class="pb-2 pt-2 d-flex align-items-center">
														<router-link :to="{ name: 'admin.courses.detail', params : { id : item.id } }" tag="a" >
										<img width="5" class="mr-1 ml-1" src="../../../assets/images/icons/solid/info.svg" /> View details
									</router-link>
													</li>
													<li v-if="user_role!='csm'" class="pb-2 pt-2 d-flex align-items-center  cursor-pointer">
														<img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
														<span> Delete</span>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="row justify-content-between ">
					<div class="col-12 col-lg-6">
						<span>Showing {{ from }} to {{ to }} of {{ total_rows }}</span>
					</div><!--col-->
					<div class="col-12 col-lg-6">
						<b-pagination align="right" :total-rows="total_rows" v-model="current_page"  @change="setPage" :per-page="parseInt(per_page)">
				    	</b-pagination>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
			<!--
			<div class="col-12 col-lg-5">
				<admin-lhcsa-dashboard-chart-1  class="w-100" />
			</div><!--col-->
		</div><!--row-->
	</div><!--container-->
</template>

<script>
	export default {
		data : function(){
			return {
				current_page : 1,
				total_rows : 15,
				per_page  : 50,
				from : 0,
				to : 0,
				courses : [],
				show_delete : false,
				course_to_delete : null,
				page_loading : true,
				search : '',
				user_role:''
			}
		},

		created : function(){
			this.user_role = this.$store.getters.getRole
			this.getCourses();
		},

		methods : {

			getCourses : function() {

				var params = {
					filters : {
						page : this.current_page,
						per_page : this.per_page,
						page_loading : this.page_loading,
						search : this.search
					}
				}
				
				this.$store.dispatch('getCourses', params).then((res) => {
					this.courses = res.data.data;

					this.current_page = res.data.meta.current_page;
					this.total_rows = res.data.meta.total;
					this.per_page = res.data.meta.per_page;
					this.total_rows = res.data.meta.total;
					this.from = res.data.meta.from;
					this.to = res.data.meta.to;
				}).catch((error) => {
					console.log(error);
				});
			},
			setPage : function(page){
				this.current_page = page;

				this.getCourses();
			},
			changePerPage : function(value, id){

				this.current_page = Math.ceil(this.from/value);
				
				this.per_page = value;
				this.page_loading = false;
				this.getCourses();
			},
			search_ : function(){
				this.page_loading = false;
				this.getCourses();
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/admin/courses/AdminCourseListComponent.vue